import { render, staticRenderFns } from "./editReportStatus.vue?vue&type=template&id=56c52a1e&scoped=true"
import script from "./editReportStatus.vue?vue&type=script&lang=js"
export * from "./editReportStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c52a1e",
  null
  
)

export default component.exports